import { __assign, __awaiter, __generator } from "tslib";
import { environment } from '../../../../environments/environment';
var ResolveApiClient = /** @class */ (function () {
    function ResolveApiClient(props) {
        this._clinicToken = props.clinicToken;
        this._authService = props.authService;
        this._onUnauthorized = props.onUnauthorized;
    }
    ResolveApiClient.toCamelCase = function (obj) {
        var newObj;
        if (obj instanceof Array) {
            return obj.map(function (value) {
                if (typeof value === 'object') {
                    value = ResolveApiClient.toCamelCase(value);
                }
                return value;
            });
        }
        else {
            newObj = {};
            for (var origKey in obj) {
                if (obj.hasOwnProperty(origKey)) {
                    var newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    var value = obj[origKey];
                    if (value instanceof Array ||
                        (value !== null && value.constructor === Object)) {
                        value = ResolveApiClient.toCamelCase(value);
                    }
                    newObj[newKey] = value;
                }
            }
        }
        return newObj;
    };
    ResolveApiClient.prototype.getReports = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.query, query = _c === void 0 ? '' : _c, _d = _a.filters, filters = _d === void 0 ? {} : _d;
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_e) {
                payload = JSON.stringify({
                    Action: 'reports',
                    Paging: {
                        Page: page,
                        PageSize: 20
                    }
                });
                return [2 /*return*/, this.fetch({
                        body: payload,
                        headers: { 'content-type': 'application/json' },
                        method: 'POST'
                    })];
            });
        });
    };
    /**
     * Essentially a wrapper around `fetch` that sets some mandatory headers
     * and behavior.
     */
    ResolveApiClient.prototype.getDefaultFetchHeaders = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var authUser, headers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._authService.getAuthSession()];
                    case 1:
                        authUser = _a.sent();
                        headers = __assign(__assign({}, (options != null && options.headers != null ? options.headers : {})), { accept: 'application/json', authorization: authUser.getIdToken().getJwtToken(), 'x-salve-clinic-token': this._clinicToken });
                        return [2 /*return*/, headers];
                }
            });
        });
    };
    ResolveApiClient.prototype.handleFetchResponse = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var content, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (response.status === 401) {
                            this._onUnauthorized();
                            throw new Error('Unauthorized');
                        }
                        if (!response.ok) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, response.text()];
                    case 2:
                        content = _a.sent();
                        result = content.length > 0 ? JSON.parse(content) : undefined;
                        // This is a workaround for the public resolve api returning PascalCase
                        return [2 /*return*/, ResolveApiClient.toCamelCase(result)];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error("Error parsing body as JSON: " + err_1.message);
                    case 4: throw new Error('Network response was not ok');
                }
            });
        });
    };
    ResolveApiClient.prototype.fetch = function (
    /** Force `headers` to be a simple object for ease of use */
    options) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDefaultFetchHeaders(options)];
                    case 1:
                        headers = _a.sent();
                        return [4 /*yield*/, fetch("" + environment.api.resolve.endpoint, __assign(__assign({}, options), { headers: headers }))];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.handleFetchResponse(response)];
                }
            });
        });
    };
    return ResolveApiClient;
}());
export { ResolveApiClient };
